export const types = Object.freeze({
  SET: '@version/set'
})
export function setApiVersion(versionApi: string) {
  return { type: types.SET, payload: { versionApi } }
}
